export default {"src":"/_next/static/media/Logo_Footer.0b12af66.svg","height":93,"width":1133,"blurWidth":0,"blurHeight":0};